import { computed, DestroyRef, inject, Injectable, NgZone, PLATFORM_ID, signal, WritableSignal } from '@angular/core';
import { DeviceScreenFamily } from '../../../shared/types/device-screen-family';
import { ScreenDevicesFamilyMinSize } from '@enums/screen-devices-family';
import { isPlatformBrowser } from '@angular/common';
import { auditTime, fromEvent, map, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceScreenFamilyService {
  private readonly TAG = 'DeviceScreenFamilyService';
  private _currentDeviceScreenFamily: WritableSignal<DeviceScreenFamily> = signal('SM');
  currentDeviceScreenFamily = computed(() => this._currentDeviceScreenFamily());
  private readonly zone = inject(NgZone);
  private readonly destroyRef = inject(DestroyRef);
  private readonly platformId = inject(PLATFORM_ID);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        const sub = fromEvent(window, 'resize')
          .pipe(
            // Emit once on start with current width
            startWith(null),
            // Read width
            map(() => window.innerWidth),
            // Throttle noisy resize
            auditTime(100),
            // Map to family
            map(w => this.getDeviceScreenFamily(w))
          )
          .subscribe(fam => {
            // Write inside Angular to notify signals
            if (fam !== this._currentDeviceScreenFamily()) {
              this.zone.run(() => this._currentDeviceScreenFamily.set(fam));
            }
          });

        this.destroyRef.onDestroy(() => sub.unsubscribe());
      });
    }
  }
  getDeviceScreenFamily(screenWidth: number): DeviceScreenFamily {
    if (screenWidth >= ScreenDevicesFamilyMinSize.lg) {
      this._currentDeviceScreenFamily.set('LG');
    } else if (screenWidth >= ScreenDevicesFamilyMinSize.md) {
      this._currentDeviceScreenFamily.set('MD');
    } else {
      this._currentDeviceScreenFamily.set('SM');
    }
    //console.log(`${this.TAG} device screenFamily = ${this.currentDeviceScreenFamily()}`);
    return this._currentDeviceScreenFamily();
  }
}
